// Load Bootstrap JS
import bootstrap from 'bootstrap'
import * as $ from "jquery";

window.jQuery = $;
window.$ = $;
